<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div class="datadisplay" id="wrapper">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/data">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
            <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container
                >
        <app-query-control-bar
            class="datadisplay component"
            id="querycontrols"
            (queryStarted)="queryStarted($event)"
        ></app-query-control-bar>

        <!-- GRAPH -->
        <div class="function-view-content" id="graph">
            <app-basic-view-graph
                [rawDataset]="this.rawDataSet"
                [functionConfig]="this.functionConfig"
                [dataIdentifiersToDisplay]="this.graphDataIdentifierToDisplay"
                [queryStarted]="this.started"
            ></app-basic-view-graph>
        </div>
        
        <!-- TABLE -->
        <div class="function-view-content" id="table">
            <app-basic-view-table
                [rawDataset]="this.rawDataSet"
                [functionConfig]="this.functionConfig"
                (dataSelected)="dataSelected($event)"
            ></app-basic-view-table>
        </div>
    </div>
    </div>
</mat-card>
